import { render, staticRenderFns } from "./PenaltyList.vue?vue&type=template&id=d1d8f470&scoped=true&"
import script from "./PenaltyList.vue?vue&type=script&lang=js&"
export * from "./PenaltyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d8f470",
  null
  
)

export default component.exports